import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Query } from 'react-apollo';
import { GET_PRODUCTS } from 'graphql/products';
import Typography from '@material-ui/core/Typography';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Spin from '../../../components/common/Spin';
import times from 'lodash/times';

const currentyear = new Date().getFullYear();
const GRADUATION_YEARS =  times(4).map(i => ({ label: currentyear + i, value: currentyear + i }));


const PlanLabel = {
  'Tier': 'Deferred Success',
  'Recurring': 'Installment',
  'One time': 'Prepaid',
};

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 30,
    padding: '10px 30px',
  },
}));

const ProductUpgrade = ({ onSelect }) => {
  const classes = useStyles();
  const [year, setYear] = useState();

  const onYearChange = (e, val) => {
    setYear(val);
  };

  return (
    <Box>
      <Box marginBottom={3}>
        <Typography gutterBottom variant="subtitle1">
          Please Select Graduation Year:
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="large"
          onChange={onYearChange}
          value={year}
        >
          {GRADUATION_YEARS.map((i) => (
            <ToggleButton key={i.value} value={i.value}>{i.label}</ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
      {year && (
        <Query query={GET_PRODUCTS} variables={{ graduation_year: year }}>
          {({ data, loading }) => {
            if (loading) return <Spin spinning linear />;
            const { products } = data;
            return (
              <Box>
                <Typography gutterBottom variant="subtitle1">
                  Please select a plan
                </Typography>
                <Box display="flex" flexWrap="wrap">
                  {products.map((i) => (
                    <Box key={i.id} margin={1} marginLeft={0}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.button}
                        onClick={() => onSelect(i)}
                      >
                        {i.package_name} - {PlanLabel[i.pricing_model]}
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Box>
            );
          }}
        </Query>
      )}
    </Box>
  );
};

export default ProductUpgrade;